export class LoudCustomRequestError extends Error {
    constructor(message) {
        super(message)

        this.name = 'LoudCustomRequestError'
    }
}
